// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail--3r8Rfzn3b","changed":"changed--2gqb21Qfc"};